import React from 'react';
import moment from 'moment';
import Container from "../editor/container"
import NewsEditor from '../editor'
import '../editor/styles.css'
import parseContent from '../editor/parseContent'

class Component extends React.Component {

  initialState = {
    modalOpen: false,
    id: false,
    content: "",
    contentObj: [],
    mode: "edit",
    subject: "",
    from: "office@cashplane.com"
  }

  state = this.initialState

  componentWillMount() {
    this.setState(this.initialState)
    if (this.props.state.subject) this.setState({subject: this.props.state.subject})
  }

  handleChange = (event) => {
    const target = event.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    value = target.type === "file" ? target.files[0] : value;
    this.setState({
      [target.name]: value
    });
    this.props.setState({
      [target.name]: value
    });    
    event.preventDefault && event.preventDefault()
  }

  selectList = (e) => {
    let listId = e.target.value
    var affiliates = ""
    for (var i = 0; i < this.props.apiListsState.items.length; i++) {
      if (parseInt(this.props.apiListsState.items[i].id) == parseInt(listId)) {
        affiliates = this.props.apiListsState.items[i].content
      }
    }
    try {
      affiliates = affiliates ? JSON.parse(affiliates) : {}  
    } catch (err) {
      console.warn("mailer contant parse err:",err)
      affiliates = {}
    }
    this.props.setState({
      list: listId,
      list_affiliates: affiliates,
      sendIndex: 0
    }, () => {
      this.setState(this.props.state)
    })
  }  

  startSending = (e) => {
    e && e.preventDefault()
    this.props.setState({sending: true, sent: false, error: false})
    this.setState({sending: true, sent: false, error: false})
    this.send()
  }

  stopSending = (e) => {
    e && e.preventDefault()
    this.props.setState({sending: false})
    this.setState({sending: false})    
  }

  send = (e) => {
    let listAffiliates = [];
    for (var aid in this.props.list_affiliates) {
      listAffiliates.push({
        aid: aid,
        email: this.props.list_affiliates[aid]
      })
    }
    let index = this.props.state.sendIndex
    let aff = listAffiliates[index]
    this.props.setState({sendAffiliate: aff})
    this.setState({sendAffiliate: aff})
    let html = this.emailRef.innerHTML
    this.props.api("mailer/sendMail",{
      email: aff.email,
      aid: aff.aid,
      from: this.state.from,
      to: aff.email,
      subject: this.state.subject,
      html: html,
      text: html
    }).then(res => {
      console.log("sendMail res:",res)
      if (res && res.result == 1 && this.props.state.sending) {
        if (listAffiliates.length > index+1) {
          this.props.setState({sendIndex: index+1}, () => {
            this.send()
          })
        } else {
          this.props.setState({sending: false, sendIndex: 0, sent: true})
          this.setState({sending: false, sendIndex: 0, sent: true})
        }
      } else {
        this.props.setState({sending: false, error: true})
        this.setState({sending: false, error: true})
      }
    })
  }

  render() {
    let listAffiliates = [];
    for (var aid in this.props.list_affiliates) {
      listAffiliates.push({
        aid: aid,
        email: this.props.list_affiliates[aid]
      })
    }    
    return (       
      <div>
        <div class="row">
          <div class="col-sm-4">
            <select
              class="form-control form-control-sm" 
              name="list" 
              value={this.props.state.list} 
              onChange={e => this.selectList(e,true)}              
            >
              <option value=""></option>
              {this.props.apiListsState.items.map((item) => 
                <option key={item.id} value={item.id}>{item.name}</option>
              )}
            </select> 
          </div>
        </div>
        {this.state.list && 
          <div>
            <table class="table box mt-2">
              <thead>
                <tr>
                  <th>aid</th>
                  <th>email</th>
                </tr>
              </thead>
              <tbody>
                {listAffiliates.map((aff) =>
                  <tr key={aff.aid}>
                    <td>{aff.aid}</td>
                    <td>{aff.email}</td>
                  </tr>
                )}
              </tbody>
            </table>
            <div>
              <label>From:
                <input 
                  class="form-control ml-2"
                  type="text" 
                  placeholder="from" 
                  name="from"
                  value={this.state.from} 
                  onChange={this.handleChange} 
                />
              </label>
            </div>            
            <div>
              <label>Subject:
                <input 
                  class="form-control ml-2"
                  type="text" 
                  placeholder="subject" 
                  name="subject"
                  value={this.state.subject} 
                  onChange={this.handleChange} 
                />
              </label>
            </div>
            <div class="news-card-content mt-2 box" ref={ref => this.emailRef = ref}>
              <Container
                el={this.props.contentObj}
                content={this.props.contentObj.content}
                parent={this}          
                root={this}
                onSelect={this.selectGrid}
                mode="render" />
            </div>
            <div class="mt-2">
              {!this.props.state.sending && <button class="btn primary" onClick={this.startSending}>Send</button>}
              {this.props.state.sending && <button class="btn primary" onClick={this.stopSending}>Stop</button>}
              {this.props.state.sending && 
                <div>
                  Sending to {this.props.state.sendAffiliate.email} (aid: {this.props.state.sendAffiliate.aid})
                </div>
              }
              {this.props.state.sent && <div>All Sent</div>}
              {this.props.state.error && <div>Error</div>}
            </div>
          </div>
        }
      </div>
    )
  }

}

import api from 'src/actions/api'
import setState from 'src/actions/state'
import { connect } from 'react-redux'

export default connect(function (state) {
  return {
    state: state.state["mailer_sender"] || state.state.initial,
    user: state.session.user,
    apiListsState: state.api.mailer_getLists || state.api.initial,
    contentObj: (state.state.mailer_composer || state.state.initial).contentObj || {},
    list_affiliates: state.state.mailer_sender && state.state.mailer_sender.list_affiliates || {}
  }
}, {
  api, 
  setState: setState("mailer_sender"),
})(Component)  